import {Link, useLocation} from "react-router-dom";
import {HEADER_MENU} from "../constants/component_constants";
import Clock from "./Clock";
import neverLandGameData from "../utils/NeverLandGameData";
import {useEffect, useState} from "react";
import {isLandscapeMode} from "../utils/componentUtils";
import {accountInfo} from "../constants/constants";
import {BASKET_PAGE, PROTO_GAME_PAGE} from "../constants/page_constants";
import neverLandUtils from "../utils/NeverLandUtils";

const Header = () => {
  const [refreshDate, setRefreshDate] = useState(new Date());
  const currentLocation = useLocation();
  const hasPermission = neverLandUtils.usePermission();
  const isShowBasket = accountInfo.getDeviceSetting()?.show_basket;

  const updateUI = () => {
    setRefreshDate(new Date());
  }
  const handleOnChanged = () => {
    updateUI();
  };

  useEffect(() => {
    neverLandGameData.addOnChangedHandler(handleOnChanged);
    return () => {
      neverLandGameData.removeOnChangedHandler(handleOnChanged);
    }
  }, []);

  return (
    <div
      className={`${isLandscapeMode() ? "w-full px-3" : "w-[62rem]"} ${accountInfo.isDarkMode() ? "text-white" : ""} h-[6rem] flex items-center overflow-x-auto justify-between`}>

      <div className="flex">
        {HEADER_MENU
          .filter((menu) => {
            // 바구니 메뉴는 권한 체크 + 설정값
            if (menu.link === BASKET_PAGE) {
              return isShowBasket && hasPermission("BASKET");
            }
            // 다른 메뉴는 모두 표시
            return true;
          })
          .map((menu) => {
            const isActive = currentLocation.pathname === menu.link;

            return (
              <Link key={menu.link}
                    to={menu.link}
                    className={`${isActive
                      ? `border-2 ${accountInfo.isDarkMode() ? "border-b-gray-900" : "border-b-white"} rounded-t-lg`
                      : "border-b-2"
                    } ${accountInfo.isDarkMode() ? "" : "border-black"} flex items-center flex-shrink-0 justify-center mt-2 py-2 text-lg min-w-36`}>
                <div className={`${isActive
                  ? `${accountInfo.isDarkMode() ? "bg-blue-600" : "bg-blue-500"} text-white shadow-md`
                  : `${accountInfo.isDarkMode() ? "bg-gray-700/50" : "bg-gray-200/50"} opacity-70`
                } rounded-lg px-4 py-2 flex items-center transition-all duration-200`}>
                  <menu.icon className="w-5 h-auto mr-2"/>
                  <span className="font-semibold">{menu.name}</span>
                </div>
              </Link>
            )
          })}
      </div>

      <div className="flex flex-row items-center mt-2">
        <button className="button-style bg-gray-600 mr-4 px-3 w-24"
                onClick={() => {
                  window.location.reload();
                }}>
          새로고침
        </button>

        {/*{currentLocation.pathname === PROTO_GAME_PAGE &&*/}
        {/*  <p className="mr-4 text-xl whitespace-nowrap">*/}
        {/*    {neverLandGameData.gameRound !== -1 ? "프로토 승부식 " + neverLandGameData.gameRound + "회차" : "정보를 가져오는 중..."}*/}
        {/*  </p>*/}
        {/*}*/}

        <Clock/>
      </div>
    </div>
  )
}
export default Header;

